"use client";

/**
 * One line above the listings results when the search is for land:
 * how many state plots take applications right now, linking to them.
 * Renders nothing when there are none (or the count cannot be read).
 */
import { useEffect, useState } from "react";
import { ChevronRight, Landmark } from "lucide-react";
import Link from "@/lib/localized-link";
import { useT } from "@/lib/locale-context";
import { auctionsApi } from "@/lib/state-auctions";

export default function StateAuctionsNote() {
  const t = useT();
  const [n, setN] = useState<number | null>(null);
  useEffect(() => {
    let cancelled = false;
    auctionsApi.list({ status: "open", kind: ["land"], limit: 1 })
      .then((r) => { if (!cancelled) setN(r.total); })
      .catch(() => { if (!cancelled) setN(null); });
    return () => { cancelled = true; };
  }, []);
  if (!n) return null;
  return (
    <Link
      href="/auctions?kind=land"
      className="mb-3 flex items-center justify-between gap-3 rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm text-gray-700 transition-colors hover:border-gray-300"
    >
      <span className="inline-flex min-w-0 items-center gap-2">
        <Landmark className="h-4 w-4 shrink-0 text-gray-500" aria-hidden />
        <span className="truncate tabular-nums">{t("sa.listings.note").replace("{n}", String(n))}</span>
      </span>
      <ChevronRight className="h-4 w-4 shrink-0 text-gray-400" aria-hidden />
    </Link>
  );
}
